const normalizeKycAddressField = (value) => {
  if (!value) return "";
  const lower = String(value).trim().toLowerCase();
  return lower === "n/a" ? "" : lower;
};

export const isCommunicationSameAsPrimary = (data) => {
  if (!data) return false;

  if (
    data.primaryAddId &&
    data.billingAddId &&
    data.primaryAddId === data.billingAddId
  ) {
    return true;
  }

  const fieldPairs = [
    ["primaryAddLine1", "billingAddLine1"],
    ["primaryAddLine2", "billingAddLine2"],
    ["primaryCityName", "billingCityName"],
    ["primaryStateName", "billingStateName"],
    ["primaryZipCode", "billingZipCode"],
  ];

  const hasBillingAddress = fieldPairs.some(([, billingKey]) =>
    normalizeKycAddressField(data[billingKey]),
  );
  if (!hasBillingAddress) return false;

  return fieldPairs.every(([primaryKey, billingKey]) =>
    normalizeKycAddressField(data[primaryKey]) ===
    normalizeKycAddressField(data[billingKey]),
  );
};

export const buildCommunicationAddressPayload = (values) => {
  if (values?.commSameAsPrimary) {
    return {
      addressLine1: values.primaryAdd1,
      addressLine2: values.primaryAdd2,
      pinCode: values.primaryPincode,
      city: values.primaryCity,
      state: values.primaryState,
    };
  }

  return {
    addressLine1: values.commAdd1,
    addressLine2: values.commAdd2,
    pinCode: values.commPincode,
    city: values.commCity,
    state: values.commState,
  };
};
